import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../common/models/Error";
import { NotificationsState } from "../models/NotificationsState";

const setError = (state: NotificationsState, action: PayloadAction<Error>) => {
    const { error } = action.payload;
    state.isError = error;
}

export default setError;